/* eslint-disable import/no-anonymous-default-export */
import { routerRedux } from 'dva/router';
import { Alert } from '../components/Alert.components';

import {
  getRequestStats,
  getOpenApplicationForms,
  getCloseApplicationForms,
  postApplication,
  getAplicationById,
  postApplicationComment,
  putApprove,
  putUnApprove,
  putDecline,
  putRequestChange,
  putUnRequestChange,
  getMyApplicationForms,
  getActivities
} from '../services/application';

const initialState = {
  myApplicationFormsList: [],
  myApplicationFormsTotal: 0,
  openApplicationFormsList: [],
  openApplicationFormsTotal: 0,
  closedApplicationFormsList: [],
  closedApplicationFormsTotal: 0,
  createRequestModal: false,
  applicationData: {},
  openConfirmationModal: false,
  requestStats: {},
  activitiesList: []
};

export default {
  namespace: 'application',

  state: {
    ...initialState
  },

  subscriptions: {
    setup() {}
  },

  effects: {
    *fetchMyApplicationForms({ payload }, { call, put, select }) {
      const { profile } = yield select(({ authentication }) => authentication);
      const { raw, success, message } = yield call(getMyApplicationForms, {
        id: profile._id,
        data: payload
      });
      if (success) {
        const list = raw?.requests;
        const total = raw?.totalItems;
        yield put({
          type: 'save',
          payload: { myApplicationFormsList: list, myApplicationFormsTotal: total }
        });
      } else {
        Alert.error(message);
      }
    },
    *fetchOpenApplicationForms({ payload }, { call, put }) {
      const { raw, success, message } = yield call(getOpenApplicationForms, payload);
      if (success) {
        const list = raw?.requests;
        const total = raw?.totalItems;
        yield put({
          type: 'save',
          payload: { openApplicationFormsList: list, openApplicationFormsTotal: total }
        });
      } else {
        Alert.error(message);
      }
    },
    *fetchCloseApplicationForms({ payload }, { call, put }) {
      const { raw, success, message } = yield call(getCloseApplicationForms, payload);
      if (success) {
        const list = raw?.requests;
        const total = raw?.totalItems;
        yield put({
          type: 'save',
          payload: { closedApplicationFormsList: list, closedApplicationFormsTotal: total }
        });
      } else {
        Alert.error(message);
      }
    },
    *fetchSingleApplication({ payload }, { call, put }) {
      const { raw, success, message } = yield call(getAplicationById, payload);
      if (success) {
        const item = raw?.request;
        yield put({
          type: 'save',
          payload: { applicationData: item }
        });
      } else {
        Alert.error(message);
      }
    },
    *fetchApplicationStats({ payload }, { call, put }) {
      const { raw, success, message } = yield call(getRequestStats, payload);
      if (success) {
        const item = raw?.requestStats;
        yield put({ type: 'save', payload: { requestStats: item } });
      } else {
        Alert.error(message);
      }
    },
    *fetchActivities({ payload }, { call, put }){ 
      const { raw, success, message } = yield call(getActivities, payload);
      if (success) {
        const list = raw?.activities;
        yield put({
          type: 'save',
          payload: {  activitiesList: list, }
        });
      } else {
        Alert.error(message);
      }
    },
    *createApplication({ payload }, { call, put }) {
      const { raw, success, message } = yield call(postApplication, payload);
      if (success) {
        Alert.success('You have successfully submited a Request');
        yield put(routerRedux.push('/applications'));
      } else {
        Alert.error(message);
      }
    },
    *createComment({ payload }, { call, put }) {
      console.log({ payload });
      const { raw, success, message } = yield call(postApplicationComment, payload);
      if (success) {
        Alert.success('You have successfully submited a comment.');
        payload?.callback();
      } else {
        Alert.error(message);
      }
    },
    *decisionApplication({ payload }, { call, put }) {
      const { type, data, id } = payload;
      let apiCall = () => {};
      switch (type) {
        case 'Approve':
          apiCall = putApprove;
          break;
        case 'Unapprove':
          apiCall = putUnApprove;
          break;
        case 'Request Change':
          apiCall = putRequestChange;
          break;
        case 'Unrequest Change':
          apiCall = putUnApprove;
          break;
        case 'Decline':
          apiCall = putDecline;
          break;

        default:
          apiCall = putUnApprove;
          break;
      }

      const { success, raw, message } = yield call(apiCall, { id, data });
      if (success) {
        yield put({ type: 'save', payload: { openConfirmationModal: false } });
        yield put({ type: 'fetchSingleApplication', payload: { id: id } });
      } else {
        Alert.error(message);
      }
    }
  },

  reducers: {
    save(state, action) {
      const newPayload = {
        ...state,
        ...action.payload
      };

      return newPayload;
    }
  }
};
